import Work1 from "../../assets/work1.png";
import Work2 from "../../assets/work2.png";
import Work3 from "../../assets/work3.png";
import Work4 from "../../assets/work4.png";
export const projectsData = [
  {
    id: 1,
    image: Work1,
    title: "React E Commerce",
    category: "web dev",
    link: "https://jkrz-react-ecommerce.vercel.app/",
  },
  {
    id: 2,
    image: Work2,
    title: "APlus Wallet",
    category: "migration",
    link: "https://www.apluswallet.com.mm",
  },
  {
    id: 3,
    image: Work3,
    title: "Little Codelab",
    category: "migration",
    link: "https://littlecodelab.com/",
  },
  {
    id: 4,
    image: Work4,
    title: "Hnj Success",
    category: "web dev",
    link: "https://hnjsuccess.com/",
  },
];
export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web dev",
  },
  {
    name: "migration",
  },
];
